import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-brand-card py-28 px-4 border-t border-brand-border pt-[0px] pb-[112px] space-y-[16px]" data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mt-[10px] mb-[0px]" data-id="element-212">
            Elegí tu <span className="text-brand-accent" data-id="element-213">PROFEPACK:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-6 items-stretch max-w-5xl mx-auto mt-[16px] gap-[32px]" data-id="element-214">
          {/* Left: Física (Order 2 on mobile, Order 1 on desktop) */}
          <motion.div className="order-2 lg:order-1 bg-brand-dark rounded-3xl p-8 border border-brand-accent flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-215">
            <div className="text-4xl text-center mb-2" data-id="element-216">⚡</div>
            <h3 className="text-2xl font-heading font-bold text-white mb-2 text-center" data-id="element-217">
              FÍSICA LISTA
            </h3>
            <p className="text-white/60 text-sm mb-8 text-center" data-id="element-218">
              Para docentes de Física de secundaria (1° a 6° año)
            </p>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-219">
              {['6 Volúmenes completos', '+120 clases con guion', 'Planificaciones para carpeta', 'Rúbricas por año', 'Experiencias con materiales mínimos', '6 Bonos incluidos', 'Acceso inmediato PDF'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-220">
                  <span className="flex-shrink-0 text-base leading-tight" data-id="element-221">
                    ✅
                  </span>
                  <span className="text-white/90 text-sm font-medium" data-id="element-222">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center mb-6 flex flex-col items-center" data-id="element-223">
              <div className="text-white/40 line-through text-base mb-1" data-id="element-224">
                $49.990 ARS
              </div>
              <div className="text-4xl font-heading font-bold text-white mb-1" data-id="element-225">
                $19.990
              </div>
              <div className="text-white/40 text-sm" data-id="element-226">ARS</div>
            </div>

            <button onClick={() => window.open('https://www.profepack.com/cart/48097185071360:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black py-4 rounded-2xl transition-colors text-base" data-id="element-227">
              → QUIERO FÍSICA LISTA
            </button>
          </motion.div>

          {/* Center: Pack Completo (Featured) (Order 1 on mobile, Order 2 on desktop) */}
          <motion.div className="order-1 lg:order-2 bg-brand-dark rounded-3xl p-8 border-2 border-brand-accent relative flex flex-col lg:scale-105 z-10" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} data-id="element-228">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-accent text-brand-dark font-badge font-black px-6 py-1.5 rounded-full text-xs whitespace-nowrap tracking-wider uppercase pb-[06px]" data-id="element-229">
              ⭐ MÁS ELEGIDO — MEJOR VALOR
            </div>

            <div className="text-4xl text-center mt-[0px] mb-[0px]" data-id="element-230">🏆</div>

            <h3 className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-2 text-center" data-id="element-231">
              PACK COMPLETO
            </h3>
            <p className="text-white/60 text-sm text-center px-4 mb-[15px]" data-id="element-232">
              Para docentes de ambas materias (Todos los niveles)
            </p>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-233">
              {['12 Tomos completos', '+240 clases con guion', 'Planificaciones para todos los niveles', 'Rúbricas Física y Química', '6 Bonos incluidos', 'Acceso inmediato PDF'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-234">
                  <span className="flex-shrink-0 text-base leading-tight" data-id="element-235">
                    ✅
                  </span>
                  <span className="text-white font-bold text-sm" data-id="element-236">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-6 flex flex-col items-center" data-id="element-237">
              <div className="line-through text-base mb-1 text-[#FE2727]" data-id="element-238">
                $99.990 ARS
              </div>
              <div className="text-5xl md:text-6xl font-heading font-bold text-brand-accent mb-1" data-id="element-239">
                $29.990
              </div>
              <div className="text-white/40 text-sm mb-3" data-id="element-240">ARS</div>
              <div className="text-brand-accent font-bold text-sm" data-id="element-241">
                ✅ AHORRÁS $9.990 ARS
              </div>
            </div>

            <motion.button className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-heading font-black text-lg py-5 rounded-2xl transition-all mb-4" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={{
            boxShadow: ['0px 0px 0px rgba(0,255,133,0)', '0px 0px 25px rgba(0,255,133,0.4)', '0px 0px 0px rgba(0,255,133,0)']
          }} transition={{
            boxShadow: {
              repeat: Infinity,
              duration: 2
            }
          }} onClick={() => window.open('https://www.profepack.com/cart/48108607242496:1', '_blank')} data-id="element-242">
              → QUIERO MI PROFEPACK COMPLETO
            </motion.button>
            <p className="text-xs text-center text-white/50 italic px-2" data-id="element-243">
              La opción más elegida por docentes que enseñan Física y Química
            </p>
          </motion.div>

          {/* Right: Química (Order 3 on mobile, Order 3 on desktop) */}
          <motion.div className="order-3 lg:order-3 bg-brand-dark rounded-3xl p-8 border border-brand-accent flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-244">
            <div className="text-4xl text-center mb-2" data-id="element-245">🧪</div>
            <h3 className="text-2xl font-heading font-bold text-white mb-2 text-center" data-id="element-246">
              QUÍMICA LISTA
            </h3>
            <p className="text-white/60 text-sm mb-8 text-center" data-id="element-247">
              Para docentes de Química de secundaria (1° a 6° año)
            </p>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-248">
              {['6 Volúmenes completos', '+120 clases con guion', 'Planificaciones para carpeta', 'Rúbricas por año', 'Experiencias con materiales mínimos', '6 Bonos incluidos', 'Acceso inmediato PDF'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-249">
                  <span className="flex-shrink-0 text-base leading-tight" data-id="element-250">
                    ✅
                  </span>
                  <span className="text-white/90 text-sm font-medium" data-id="element-251">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="text-center mb-6 flex flex-col items-center" data-id="element-252">
              <div className="text-white/40 line-through text-base mb-1" data-id="element-253">
                $49.990 ARS
              </div>
              <div className="text-4xl font-heading font-bold text-white mb-1" data-id="element-254">
                $19.990
              </div>
              <div className="text-white/40 text-sm" data-id="element-255">ARS</div>
            </div>

            <button onClick={() => window.open('https://www.profepack.com/cart/48097186545920:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark font-black py-4 rounded-2xl transition-colors text-base" data-id="element-256">
              → QUIERO QUÍMICA LISTA
            </button>
          </motion.div>
        </div>

        {/* Trust Row */}
        <div className="mt-16 flex flex-wrap justify-center gap-6 md:gap-12 text-white/40 font-medium text-sm" data-id="element-257">
          <div className="flex items-center gap-2" data-id="element-258">
            <Lock size={18} className="text-brand-accent" data-id="element-259" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-260">
            <Zap size={18} className="text-brand-accent" data-id="element-261" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-262">
            <ShieldCheck size={18} className="text-brand-accent" data-id="element-263" /> Garantía 7
            días
          </div>
          <div className="flex items-center gap-2" data-id="element-264">
            <CreditCard size={18} className="text-brand-accent" data-id="element-265" /> Mercado Pago
            / Tarjeta / Transferencia
          </div>
        </div>
      </div>
    </section>;
}